import httpClient from "./httpClient";

const base = "/admit-card-instructions";

export function getAdmitCardInstruction(examConfigId) {
  return httpClient.get(base, { params: { examConfigId } }).then((res) => res.data.data);
}

export function saveAdmitCardInstruction(payload) {
  return httpClient.put(base, payload).then((res) => res.data.data);
}
